import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Zipkin',
    templateUrl: './Zipkin.component.html'
})
export class ZipkinComponent implements OnInit {

    consumerID: string;
    http_endpoint: string;
    sample_ratio = 0.001;

    data = {
        'consumerID' : this.consumerID,
        'http_endpoint' : this.http_endpoint,
        'sample_ratio' : this.sample_ratio,
        'plugin' : 'zipkin'
    }
    constructor() { }

    Zipkin() {
    }
    ngOnInit() {
    }

}
